import axios from "axios";
import { authHeader } from "./auth-header";

import { URL_API } from "./Commons";

class NotaDiariaService {
  async getAll() {
    return await axios.get(URL_API + "notadiarias", { headers: authHeader() });
  }

  async getPaginacao(quant = 10) {
    return await axios.get(URL_API + "notadiariatake/0/" + quant, {
      headers: authHeader(),
    });
  }

  async getOne(id) {
    return axios.get(URL_API + "notadiaria/" + id, { headers: authHeader() });
  }

  async search(word) {
    return await axios.post(
      URL_API + "notadiariasearch",
      { search: word },
      { headers: authHeader() }
    );
  }
}

export default new NotaDiariaService();
